import { render, staticRenderFns } from "./suspend.vue?vue&type=template&id=4dd490e8&scoped=true"
import script from "./suspend.vue?vue&type=script&lang=js"
export * from "./suspend.vue?vue&type=script&lang=js"
import style0 from "./suspend.vue?vue&type=style&index=0&id=4dd490e8&prod&lang=css"
import style1 from "./suspend.vue?vue&type=style&index=1&id=4dd490e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd490e8",
  null
  
)

export default component.exports